








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
  }
})
export default class LandingProtection extends mixins(PlanLimitsMixin) {
  @Prop() 
  secretKey!: any;
}
